<template>
  <div class="col-11 col-md-7 col-lg-6 col-xl-4 col-xxl-3 side-sheet show scrollbar-style">
    <div class="sidesheet-inner">
      <div class="pt-3 px-3"><h2>Notes</h2></div>
      <div class="messages">
        <ol class="history flex-grow-1">
          <li class="text-muted" v-if="notes.length == 0">No Messages.</li>
          <note v-for="note in notes" :key="note.id" :note="note"></note>
        </ol>
        <div class="message-new">
          <div class="inner">
            <div class="row gx-2">
              <div class="col col-message">
                <label class="visually-hidden">New Note</label>
                <textarea
                  v-model="newNote.note"
                  placeholder="New note"
                  name="note"
                  rows="3"
                  class="form-control"
                  v-validate="'required'"
                  data-vv-validate-on="input|blur"
                  data-vv-as="note"
                ></textarea>
              </div>
              <div class="col-auto col-send">
                <c-button @click="handleAdd" variant="light" class="btn btn-sm btn-light"><i class="fas fa-paper-plane"></i></c-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Note from './Note'
import { http } from "utils";
import { mapState, mapActions, mapGetters } from 'vuex'
import { notify } from 'utils'

export default {
  $_veeValidate: {
    validator: 'new' // give me my own validator scope.
  },
  components: {
    Note
  },
  props: [
    'type'
  ],
  data() {
    return {
      newNote: {},
    };
  },
  computed: {
    ...mapState('notes', {
      notes: 'list'
		}),
  },
  methods: {
    ...mapActions('notes', {
			getNotes: 'getList'
		}),
    ...mapActions('notes', ['addSingle']),
    async handleAdd() {

      if (!await this._validate()) {
        notify.error('Form validation failed, please check your inputs and try again.')
        return
      }

      try {
          return this.addSingle(this.newNote).then((response) => {
            this.$nextTick(() => {
              this.$validator.reset();
            });

            this.newNote = {}
          }).catch((error) => {
              if (error.response.status === 422) {
                  notify.error('Form validation failed, please check your inputs and try again.')
              } else {
                  notify.error('Failed to create Note, please try again.')
              }
          })
      }
      catch(error) {
          notify.error(error)
      }
    },
  },

  mounted() {
    this.getNotes();
  },
};
</script>

<style lang="scss" scoped>
.scrollbar-style::-webkit-scrollbar {
  display: none;
}

.sidesheet-inner {
  .messages .message-new .inner {
    border: 1px solid #dee2e6;
    border-radius: 0.125rem;
    padding: 0.25rem;

    .form-control {
      border: none;
      padding: 0 0.25rem;
      line-height: 1.5;
    }

    .col-send {
      display: flex;
    }
  }
}
</style>
